import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import {
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { DialogModule } from '@angular/cdk/dialog';
import { ApiModule, Configuration } from './app/api-client';
import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { ConfigService } from './app/services/config/config.service';
import { NavigationRouteService } from './app/services/navigation-route/navigation-route.service';
import { provideKeycloak, includeBearerTokenInterceptor, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG } from 'keycloak-angular';

fetch('./assets/config/config.json')
  .then((res) => res.json())
  .then(async (config) => {
    const configService = new ConfigService();
    configService['config'] = config; // Assign the loaded config to the service

    // Create navigation route service and convert routes
    const navigationRouteService = new NavigationRouteService();
    const dynamicRoutes = navigationRouteService.convertToAngularRoutes(config.navigation || []);

    const apiConfig = new Configuration({
      basePath: config.apiBasePath, // Use basePath from the loaded config
      accessToken: () => {
        // Get token from localStorage (updated by the interceptor)
        return localStorage.getItem('authToken') || '';
      },
    });

    const extendedAppConfig = {
      ...appConfig,
      providers: [
        // Remove the static router provider from appConfig and add dynamic one
        ...(appConfig.providers?.filter(provider =>
          !(typeof provider === 'function' && provider.toString().includes('provideRouter'))
        ) || []),
        provideRouter(dynamicRoutes), // Use dynamic routes from config
        provideHttpClient(
          withInterceptors([includeBearerTokenInterceptor])
        ),
        {
          provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
          useValue: [
            {
              urlPattern: new RegExp(`^${config.apiBasePath.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`),
              httpMethods: ['GET', 'POST', 'PUT', 'DELETE', 'PATCH']
            },
            {
              urlPattern: new RegExp(`^${config.simulatorBasePath.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`),
              httpMethods: ['GET', 'POST', 'PUT', 'DELETE', 'PATCH']
            }
          ]
        },
        importProvidersFrom(ApiModule.forRoot(() => apiConfig)),
        importProvidersFrom(DialogModule),
        provideKeycloak({
          config: {
            url: config.auth.keycloak.url,
            realm: config.auth.keycloak.realm,
            clientId: config.auth.keycloak.clientId,
          },
          initOptions: {
            onLoad: 'login-required',
            checkLoginIframe: false,
          },
        }),
        provideAnimations(),
        provideToastr({ ...config.toastr }), // Use toastr config from the loaded config
        { provide: ConfigService, useValue: configService }, // Provide the ConfigService with the loaded config
      ],
      imports: [BrowserAnimationsModule],
    };

    bootstrapApplication(AppComponent, {...extendedAppConfig, providers: [provideZoneChangeDetection(), ...extendedAppConfig.providers]}).catch((err) =>
      console.error(err)
    );
  })
  .catch((err) => console.error('Failed to load config.json:', err));
